export enum OVERVIEW_SIZES_ENUM {
    SMALL = 'small',
    MEDIUM = 'medium',
    LAGRE = 'large',
}

export enum VALUE_TYPES {
    CURRENCY = 'currency',
    PERCENT = 'percent',
    NUMBER = 'number',
    TEXT = 'text',
    RATIO = 'ratio',
}

export interface ValueWithLinks {
    label: string | undefined;
    linkTo: string | undefined;
}

export interface OverviewItemProps {
    title: string;
    value?: ValueWithLinks[] | string | number | null;
    size?: OVERVIEW_SIZES_ENUM;
    currencySize?: OVERVIEW_SIZES_ENUM;
    type?: VALUE_TYPES;
    colored?: boolean;
    percent?: number | null,
    percentTooltip?: string | null,
    link?: string,
    linkLabel?: string,
    itemLink?: string,
    currency?: string,
    icon?: string,
    iconColored?: boolean,
    additionalValue?: string,
    RenderValue?: any,
    className?: string,
    valueLinks?: string[],
}
